module.exports = __webpack_public_path__ + "img/logo.52c462f0.png";